<template>
    <div class="vue-template">
        <div class="container">
            <div class="section-title">
                <h2 class="title">{{ $t("catalog.Catalog") }}</h2>
                <p class="subtitle">{{ $t("catalog.subtitle") }}</p>
            </div>
            <div class="catalog-filter">
                <information-box :category="currentCategory"></information-box>

            </div>
        </div>
        <category-filter v-bind:categories="categories"
                         v-bind:active_id="activeCategoryId"
                         v-on:active-changed="activeCatChanged"
                         @active-changed-last="scrollToProducts"
        ></category-filter>
        <!-- catalog list-->
        <div class="catalog-list" id="catalog-list" >
            <div class="container" id="catalog-container"
                 v-infinite-scroll="loadMore"
                 infinite-scroll-disabled="busy"
                 infinite-scroll-distance="600"
                 infinite-scroll-throttle-delay="100"
            >
                <div class="row">
                    <div class="col-lg-4 col-md-6" v-for="(model) in products">
                        <product-item :item="model" v-on:open-modal="modalData"></product-item>
                    </div>
                </div>
                <!--<div class="row">
                    <div class="col-12">
                        <div class="pagination">
                            <ul class="pagination-list">
                                <li class="pagination-item">
                                    <a class="pagination-link pagination-btn disabled" href="#">
                                        <svg class="icon">
                                            <use xlink:href="#ic-arr-left"></use>
                                        </svg>
                                    </a></li>
                                <li class="pagination-item is-active">
                                    <a class="pagination-link" href="javascript:void(0);">1</a>
                                </li>
                                <li class="pagination-item">
                                    <a class="pagination-link" href="javascript:void(0);">2</a>
                                </li>
                                <li class="pagination-item">
                                    <a class="pagination-link" href="javascript:void(0);">3</a>
                                </li>
                                <li class="pagination-item">...</li>
                                <li class="pagination-item">
                                    <a class="pagination-link" href="javascript:void(0);">10</a>
                                </li>
                                <li class="pagination-item">
                                    <a class="pagination-link pagination-btn" href="#">
                                        <svg class="icon">
                                            <use xlink:href="#ic-arr-right"></use>
                                        </svg>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>-->
            </div>
        </div>
    </div>
</template>
<script>
    import i18n from './plugins/i18n.js';
    import categoryFilter from './category-filter.vue';
    import informationBox from './information-box.vue';
    import infiniteScroll from 'vue-infinite-scroll';

    export default {
        i18n,
        data: function () {
            return {
                item: null,
                isModalOpen: false,
                activeCategoryId: null,
                activeSubCategoryId: null,
                showedProducts: 0,
                busy: false
            }
        },
        directives: {
            infiniteScroll
        },
        props: ['categories', 'checkoutUrl', 'cartItems', 'combinations'],
        components: {
            'category-filter': categoryFilter,
            'information-box': informationBox,
            'product-item': () => import(/* webpackChunkName: "product-item" */'./product-item.vue'),
            'modal-item': () => import(/* webpackChunkName: "modal-item" */'./modal-item.vue')
        },
        mounted() {
            const location = window.location.pathname.split('/');
            if (location.length>2) {
                // document.getElementById('catalog').scrollIntoView();
                const currentCategorySlug = location[location.length-1];

                const currentCat = this.categories.find(item => item.slug === currentCategorySlug);
                if (currentCat) {
                    this.activeCategoryId = currentCat.id;
                }
            }
        },
        computed: {
            allCategory: function () {
                return this.categories.find(item => item.id === null)
            },
            currentCategory: function () {
                return this.categories.find(item => item.id === this.activeCategoryId)
            },
            currentProducts: function () {
                if (this.activeCategoryId === null) {
                    return this.currentCategory.models ? this.currentCategory.models : [];
                }
                const cat_id = this.activeCategoryId;
                let models = this.allCategory.models.filter((model) => {
                    return model.categories ? model.categories.indexOf(cat_id) > -1 : false;
                });
                models.forEach((model) => {
                    const combination = model.combinations.find(com => parseInt(com.id) === parseInt(this.currentCategory.catalog_combination_id));
                    if (combination) {
                        model.com_id = combination.id;
                        model.price = combination.price;
                        model.in_cart = combination.in_cart;
                        model.base_price = combination.old_price;
                        model.quantity = combination.quantity;
                    }
                });
                models.sort((a, b) => {
                    if ((a.quantity > 0) > (b.quantity > 0)) {
                        return -1;
                    }
                    if ((a.quantity > 0) < (b.quantity > 0)) {
                        return 1;
                    }
                    return 0;
                });
                return models;
            },
            products: function () {
                return this.currentProducts.slice(0, this.showedProducts);
            }
        },
        watch: {
            currentCategory: function(newCategory, oldCategory) {
              const currentLang = document.getElementById('current-lang');
                if (newCategory.parent_id) {

                    let parent = this.categories.find(item => item.id === newCategory.parent_id);
                    if (parent.parent_id) {
                      let grandparent = this.categories.find(item => item.id === parent.parent_id);
                      const pushStateUrl = js_vars.current_language === 'uk' ? '/uk/categories/'+grandparent.slug+'/'+parent.slug+'/'+newCategory.slug :  '/categories/'+grandparent.slug+'/'+parent.slug+'/'+newCategory.slug
                      const pushStateUrlHref = js_vars.current_language === 'uk' ? '/categories/'+grandparent.slug+'/'+parent.slug+'/'+newCategory.slug :  '/uk/categories/'+grandparent.slug+'/'+parent.slug+'/'+newCategory.slug
                      window.history.pushState("", "", pushStateUrl);
                      currentLang.href = pushStateUrlHref
                      return;
                    }
                    const pushStateUrl = js_vars.current_language === 'uk' ? '/uk/categories/'+parent.slug+'/'+newCategory.slug :  '/categories/'+parent.slug+'/'+newCategory.slug
                    const pushStateUrlHref = js_vars.current_language === 'uk' ? '/categories/'+parent.slug+'/'+newCategory.slug :  '/uk/categories/'+parent.slug+'/'+newCategory.slug
                    window.history.pushState("", "", pushStateUrl);
                    currentLang.href = pushStateUrlHref
                    return;
                }
                const pushStateUrl = js_vars.current_language === 'uk' ? '/uk/categories/'+newCategory.slug :  '/categories/'+newCategory.slug
                const pushStateUrlHref = js_vars.current_language === 'uk' ? '/categories/'+newCategory.slug :  '/uk/categories/'+newCategory.slug
                window.history.pushState("", "", pushStateUrl);
                currentLang.href = pushStateUrlHref
            },
            cartItems: function (newItems, oldItems) {
                if ('models' in this.allCategory) {
                    this.allCategory.models.forEach((model) => {
                        model.in_cart = false;
                        model.combinations.forEach(function (com) {
                            com.in_cart = false;
                        });
                        newItems.forEach(function (cart_item) {
                            model.combinations.forEach(function (com) {
                                if (cart_item.id === model.id && com.id === cart_item.com_id) {
                                    com.in_cart = true;
                                }
                            });
                            if (cart_item.id === model.id && cart_item.com_id === model.com_id) {
                                model.in_cart = true
                            }
                        })
                    })
                }
            }
        },
        methods: {
            scrollToProducts()
            {
                const container = this.$el.querySelector("#catalog-list");
                container.scrollIntoView({block: "start", inline: "nearest",behavior:"smooth"});
                // container.scrollIntoView();
                // container.scrollIntoView({block: "start", inline: "start"});
              // console.log('scroll');
            },
            modalData: function (opened, data) {
                if (data) {
                    this.item = data;
                }
                this.isModalOpen = opened;
                if (this.isModalOpen === true) {
                    document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
                } else {
                    document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
                }
            },
            activeCatChanged: function (val) {
                this.activeCategoryId = val;
                this.showedProducts = 9;
            },
            loadMore: function () {
                this.busy = true;
                this.showedProducts += 9;
                this.busy = false;
            }
        },
    };
</script>
